import RenderIf from '../RenderIf/RenderIf';
import React, {useMemo} from 'react';
import {ErrorRetryRequestButton} from './ErrorRetryRequestButton';
import config from '../../helpers/config';
import {parseDate} from '../../helpers/dates';
import {ErrorRetryRequestControlsProps} from '../../@types/components/ErrorRepresentation';
import ErrorNextRetryDetails from './ErrorNextRetryDetails';

export default function ErrorRetryControls(props: ErrorRetryRequestControlsProps) {
    const {
        retryButtonLabel,
        retryOnClick = () => {// eslint-disable-line
        },
        retryInProcess = false,
        retryAttempts,
        retryLastAttemptAt,
        nextTryInSecondsText,
        nextTrySoonText,
        nextTryNowText,
        triedAttemptsText,
    } = props;

    const [timeoutInSeconds, maxAttemptsNumber] = useMemo<number[]>(() => {
        return [
            config('client.failed-request.retry-timeout-in-seconds', 15),
            config('client.failed-request.max-attempts', 10),
        ];
    }, []);
    const lastAttemptAtDate = useMemo(() => {
        return retryLastAttemptAt ? parseDate(retryLastAttemptAt).add(timeoutInSeconds, 'seconds') : null;
    }, [retryLastAttemptAt, timeoutInSeconds]);

    const retryButtonDisabled = useMemo<boolean>(() => {
        return retryAttempts !== undefined && (retryAttempts < maxAttemptsNumber);
    }, [retryAttempts, maxAttemptsNumber]);

    const shouldDisplay = (
            retryButtonLabel ||
            retryButtonDisabled && lastAttemptAtDate && nextTryInSecondsText ||
            retryAttempts !== undefined && triedAttemptsText
    );

    if (!shouldDisplay) {
        return null;
    }

    return <>
        <hr/>

        <div className="d-flex align-items-center">
            <RenderIf expression={retryButtonLabel} render={(retryButtonLabel) => {
                return <ErrorRetryRequestButton
                        label={retryButtonLabel}
                        disabled={retryButtonDisabled}
                        onClickHandler={retryOnClick}
                />;
            }}/>

            <ErrorNextRetryDetails {...{
                maxAttemptsNumber,
                retryButtonDisabled,
                lastAttemptAtDate,
                retryInProcess,
                retryAttempts,
                nextTryInSecondsText,
                nextTrySoonText,
                nextTryNowText,
                triedAttemptsText,
            }}/>
        </div>
    </>;
}
